// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare global {
  interface String {
    // Already in TS
    // replaceAll: (search: String | string, replacement: String | string) => String | string;
    pregQuote: (delimiter?: String | string) => String | string;
    capitalize: () => String | string;
    capitalizeEachWord: (delimiter?: String | string) => String | string;
    trimAll: () => String | string;
  }

  interface StringConstructor {
    isString(value: any): boolean;
  }
}

// Already in TS
// String.prototype.replaceAll = function (search: String | string, replacement: String | string): String | string {
//   return this.split(search as string).join(replacement as string);
// };

String.prototype.pregQuote = function (delimiter: String | string = ''): String | string {
  // Escape the delimiter first if it exists to safely inject into the character class
  const escapedDelimiter = (delimiter ? delimiter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '');
  // The core regex for special characters
  const regex = new RegExp(`[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-${escapedDelimiter}]`, 'g');

  return this.replace(regex, '\\$&');
};

String.prototype.capitalize = function (): String | string {
  if (this.length > 1) {
    const firstChar = this[0];
    if (firstChar)
      return (firstChar.toUpperCase() + this.slice(1));
  }
  return this;
};

String.prototype.capitalizeEachWord = function (delimiter: String | string = ' '): String | string {
  return this.split((delimiter as string)).map((item: string) => {
    return item.capitalize();
  }).join((delimiter as string));
};

String.prototype.trimAll = function (): String | string {
  return this.replace(/\s/g, '');
};

String.isString = function (value: any): boolean {
  return ((typeof value === 'string') || (value instanceof String));
};
